module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/win11-start-light-bgimage.743803d6.svg";